import { LifeBuoy } from "lucide-react";
import TopBar from "../components/TopBar";
import EmptyState from "../components/EmptyState";

export default function SupportPage() {
  return (
    <>
      <TopBar title="Support" subtitle="CommandLinc self-service and escalation." />
      <div className="panel">
        <div className="panel-body">
          <EmptyState
            title="Support coming soon."
            subtitle="A dedicated in-app support surface will land in a later phase. For now, escalations go directly to the Director."
            icon={LifeBuoy}
          />
        </div>
      </div>
    </>
  );
}
